export default {
    CSACountReadUserAction: {
        datapoint: {
            name: 'CSACountReadUserAction',
            customData: function (actionName, actionSource) { return [
                actionName,
                actionSource,
            ]; },
        },
    },
    CSACountComposeUserAction: {
        datapoint: {
            name: 'CSACountComposeUserAction',
            customData: function (actionName, actionSource) { return [
                actionName,
                actionSource,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map